<section id="benefits" class="section-padding bg-mint/5 relative">
  <!-- Decorative Circle -->
  <div class="absolute top-1/2 left-0 transform -translate-x-1/2 -translate-y-1/2 w-72 h-72 rounded-full bg-mint/10 filter blur-3xl"></div>

  <div class="container mx-auto px-4 md:px-6 relative z-10">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <div class="appear-on-scroll opacity-0">
        <span class="subtitle mb-3">Why Choose Our Products</span>
        <h2 class="heading-lg mb-6">Ancient Wisdom for Modern Wellness</h2>
        <p class="body-md text-forest/80 mb-8">
          Our premium health products combine centuries-old herbal traditions with modern science to create effective, natural solutions for today's wellness needs.
        </p>
        <ul class="space-y-5">
          <li *ngFor="let item of checklist" class="flex items-start gap-3">
            <span class="flex-shrink-0 rounded-full bg-mint p-1">
              <!-- Check Icon SVG -->
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-forest" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
            </span>
            <span class="text-forest">{{ item }}</span>
          </li>
        </ul>
      </div>

      <div class="grid grid-cols-1 gap-6">
        <div *ngFor="let benefit of benefits; let i = index"
             class="appear-on-scroll opacity-0 glass-card p-6 rounded-xl transition-all duration-300 hover:shadow-lg"
             [style.animationDelay]="i * 150 + 'ms'">
          <div class="flex gap-4">
            <div class="flex-shrink-0 bg-white/60 w-16 h-16 rounded-full flex items-center justify-center shadow-sm">

              <!-- Dynamic Icon -->
              <ng-container [ngSwitch]="benefit.icon">
                <i-lucide *ngSwitchCase="'leaf'" [img]="LeafIcon" class="text-forest" size="32"></i-lucide>
                <i-lucide *ngSwitchCase="'activity'" [img]="ActivityIcon" class="text-forest" size="32"></i-lucide>
                <i-lucide *ngSwitchCase="'brain'" [img]="BrainIcon" class="text-forest" size="32"></i-lucide>

                <!-- <svg *ngSwitchCase="'activity'" xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-mint-dark" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m-1-4a9 9 0 110 18 9 9 0 010-18z" />
                </svg>
                <svg *ngSwitchCase="'brain'" xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-mint-dark" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4c-1.1 0-2 .9-2 2a2 2 0 000 4c1.1 0 2-.9 2-2a2 2 0 012-2c1.1 0 2 .9 2 2a2 2 0 000 4c-1.1 0-2 .9-2 2a2 2 0 000 4c1.1 0 2-.9 2-2a2 2 0 00-2-2c-1.1 0-2 .9-2 2a2 2 0 000 4c1.1 0 2-.9 2-2" />
                </svg> -->
              </ng-container>
            </div>
            <div>
              <h3 class="font-cormorant text-xl font-semibold mb-2">{{ benefit.title }}</h3>
              <p class="text-forest/80 text-sm">{{ benefit.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
